export default {
  data () {
    return {
      // Sorteio de 50% feito no código; o mapping do Montilla só filtra por
      // `hotjar_sample` (ver `content_view` das páginas que usam o mixin).
      hotjarSample: false,
    }
  },
  mounted () {
    /*
     * Only load Hotjar part of the time, to try preserving user data for times we
     * don't really use all the traffic. Which means the user can download less
     * stuff, and our performance be better.
     * Mixin hooks run before the page's own `mounted`, so the flag is ready
     * when the page fires its `content_view`.
     */
    this.hotjarSample = Math.random() < 0.5
  },
}
